function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.24,
    height: 15.24,
    viewBox: "0 0 4.032 4.032",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillRule: "evenodd",
      strokeWidth: 0.0214633
    },
    transform: "matrix(.64316 .76573 -.71775 .6963 -77.19 -137.274)",
    d: "M155.176 26.514h.699v4.992h-.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillRule: "evenodd",
      strokeWidth: 0.0214633
    },
    transform: "matrix(.76573 -.64316 .6963 .71775 -77.19 -137.274)",
    d: "M-40.591 155.51h.699v4.992h-.699z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonClose);
export default __webpack_public_path__ + "static/media/button_close.beeefe6a763e5137385642fe8f105bdf.svg";
export { ForwardRef as ReactComponent };